import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { EmptyDecoration } from "./empty-decoration";
const parseFontWeight = (fontWeight) => {
  if (fontWeight === "bold") {
    return 700;
  }
  if (fontWeight === "normal") {
    return 400;
  }
  return parseInt(fontWeight, 10);
};
class BoldDecoration {
  constructor(customStyle) {
    this.type = Decoration_Type.BOLD;
    this.customStyle = customStyle;
  }
  static of(decoration) {
    if (decoration.type !== Decoration_Type.BOLD) {
      throw new TypeError(`invalid decoration initializer ${decoration}`);
    }
    return new BoldDecoration({ fontWeight: decoration.fontWeightValue });
  }
  getDecoration() {
    return {
      type: this.type,
      fontWeightValue: parseFontWeight(this.customStyle.fontWeight)
    };
  }
  static fromCustomStyle(customStyle) {
    return new BoldDecoration(customStyle);
  }
  fromCustomStyle(customStyle) {
    return BoldDecoration.fromCustomStyle(customStyle);
  }
  toCustomStyle() {
    return this.customStyle;
  }
  overrideWith(decoration) {
    if (!(decoration instanceof BoldDecoration || decoration instanceof EmptyDecoration)) {
      throw new TypeError(`invalid merge decoration ${decoration}`);
    }
    const customStyle = { ...this.customStyle, ...decoration.toCustomStyle() };
    return new BoldDecoration(customStyle);
  }
}
export {
  BoldDecoration
};
//# sourceMappingURL=bold-decoration.js.map
